import { useTranslation } from "react-i18next";
import { NavLink } from "../../app/NavBar/NavBarElements";
import { ReactElement } from "react";
import { useLocation } from "react-router-dom";
import { conditionallyHighlighted } from "../../../utils/cssUtils";

const VolonteerListLink = (): ReactElement => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <NavLink
      to="/volonteri"
      highlighted={conditionallyHighlighted(pathname, "/volonteri")}
    >
      {t("volunteerList")}
    </NavLink>
  );
};

export default VolonteerListLink;
